<template>
	<div class="p-grid">

		<div class="p-col-12">			
			<div class="card">
				<Panel header="CONTROL DE DOCENTES ADSCRITOS A LA INSTITUCIÓN" style="height: 100%">

				<Toolbar class="p-mb-4">
					<template v-slot:left>
						<Button label="Registrar Docente" icon="pi pi-plus" class="p-button-success p-mr-2" @click="openNew" />						
					</template>
					<template v-slot:right>
						<span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                        </span>
					</template>
				</Toolbar>
				
				<DataTable :value="listaDocentes" v-model:selection="newdocenteItem" class="p-datatable-gridlines" dataKey="noPlaza" :filters="filters" :rows="5" style="margin-bottom: 20px" :paginator="true"
				responsiveLayout="scroll" :rowsPerPageOptions="[5,10,25]">				
				<Column field="noPlaza" header="No. Plaza" :sortable="true" style="width:70px;text-align:center"></Column>				
				<Column field="apellidoPaterno" header="Ape. Paterno" :sortable="true"></Column>
				<Column field="apellidoMaterno" header="Ape. Materno"></Column>
				<Column field="nombreDocente" header="Nombre Completo"></Column>
				<Column field="categoria" header="Categoría" :sortable="true"></Column>
				<Column field="tipoContrato" header="Contrato" :sortable="true"></Column>
				<Column field="fechaIngreso" header="Fecha Ingreso"></Column>
				<Column style="width:150px">
					<template #header>
						Acciones
					</template>
					<template #body="slotProps">
                        <Button icon="pi pi-id-card" type="button" class="p-button-primary p-mr-2 p-mb-1" @click="showCV(slotProps.data)"></Button>
						<Button icon="pi pi-pencil" type="button" class="p-button-success p-mr-2 p-mb-1" @click="showeditDocente(slotProps.data)"></Button>
                        <Button icon="pi pi-trash" type="button" class="p-button-danger p-mb-1" @click="confirmDeleteDocente(slotProps.data)"></Button>
					</template>
				</Column>
			</DataTable>
				
			</Panel>
			<br>
			<Toast/>

			<Dialog v-model:visible="nuevoDocenteDialog" :style="{width: '470px'}" header="Registrar Nuevo Docente" :modal="true" class="p-fluid">
					<div class="p-field">
						<label for="name">No. Plaza:</label>
						<InputText id="tiempo"  v-model="newdocenteItem.noPlaza" required="true" autofocus integeronly :class="{'p-invalid': submitted && validarErrores.noplaza}"/>
						<small class="p-error" v-show="submitted && validarErrores.noPlaza">El número de plaza es requerido.</small>
					</div>
					<div class="p-field">
						<label for="name">Nombre(s):</label>
						<InputText id="nom" v-model="newdocenteItem.nombre" required="true" :class="{'p-invalid': submitted && validarErrores.nombre}" />
						<small class="p-error" v-show="submitted && validarErrores.nombre">El nombre es requerido.</small>
					</div>					
					<div class="p-field">
						<label for="name">Apellido Paterno:</label>
						<InputText id="tiempo"  v-model="newdocenteItem.apellidoPaterno" required="true" :class="{'p-invalid': submitted && validarErrores.apellidoPaterno}"/>
						<small class="p-error" v-show="submitted && validarErrores.apellidoPaterno">El apellido Paterno es requerido.</small>
					</div>
					<div class="p-field">
						<label for="name">Apellido Materno:</label>
						<InputText id="nom" v-model="newdocenteItem.apellidoMaterno" required="true" :class="{'p-invalid': submitted && validarErrores.apellidoMaterno}" />
						<small class="p-error" v-show="submitted && validarErrores.apellidoMaterno">El apellido Materno es requerido.</small>
					</div>													
					
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-danger" @click="hideDialog"/>
						<Button label="Guardar " icon="pi pi-check" class="p-button-primary" @click="saveDocente" />
					</template>
			</Dialog>

			<Dialog v-model:visible="editarDialog" :style="{width: '470px'}" header="Editar Datos del Docente" :modal="true" class="p-fluid">
					<div class="p-field">
						<label for="name">No. Plaza:</label>
						<InputText id="tiempo"  v-model="newdocenteItem.noPlaza" required="true" autofocus integeronly :class="{'p-invalid': submitted && validarErrores.noplaza}"/>
						<small class="p-error" v-show="submitted && validarErrores.noPlaza">El número de plaza es requerido.</small>
					</div>
					<div class="p-field">
						<label for="name">Nombre(s):</label>
						<InputText id="nom" v-model="newdocenteItem.nombre" required="true" :class="{'p-invalid': submitted && validarErrores.nombre}" />
						<small class="p-error" v-show="submitted && validarErrores.nombre">El nombre es requerido.</small>
					</div>					
					<div class="p-field">
						<label for="name">Apellido Paterno:</label>
						<InputText id="tiempo"  v-model="newdocenteItem.apellidoPaterno" required="true" :class="{'p-invalid': submitted && validarErrores.apellidoPaterno}"/>
						<small class="p-error" v-show="submitted && validarErrores.apellidoPaterno">El apellido Paterno es requerido.</small>
					</div>
					<div class="p-field">
						<label for="name">Apellido Materno:</label>
						<InputText id="nom" v-model="newdocenteItem.apellidoMaterno" required="true" :class="{'p-invalid': submitted && validarErrores.apellidoMaterno}" />
						<small class="p-error" v-show="submitted && validarErrores.apellidoMaterno">El apellido Materno es requerido.</small>
					</div>								
					
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-danger" @click="hideDialogEditar"/>
						<Button label="Editar " icon="pi pi-check" class="p-button-primary" @click="editDocente" />
					</template>
			</Dialog>


			<Dialog v-model:visible="deleteDocenteDialog" :style="{width: '450px'}" header="Confirmar eliminación" :modal="true">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
						<span>¿ Deseas eliminar el Docente seleccionado ?</span>
					</div>
					<template #footer>
						<Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteDocenteDialog = false"/>
						<Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteDocente" />
					</template>
			</Dialog>

			<Dialog v-model:visible="mostrarCVDialog" :style="{width: '950px',height:'650px'}" header="CV Docente Formato CONAIC" :modal="true" class="p-fluid">				
				<div>
					<iframe id="pdf-js-viewer" src="https://christianmce.net/reportes/print_cvdocente_pdf.php?np=8701" title="webviewer" frameborder="0" width="930" height="600"></iframe>
				</div>				
			</Dialog>

			</div>			
		</div>
	</div>
</template>
<script>
import apiDocentesAdmin from '@/service/DocentesService';
import { FilterMatchMode } from 'primevue/api';

export default {
		data() {
				return{
					listaDocentes: [],
					newdocenteItem: {
						noPlaza: null,
						nombre: null,
						apellidoPaterno:null,
						apellidoMaterno:null
					},
					nuevoDocenteDialog: false,
					mostrarCVDialog: false,
					editarDialog: false,
					deleteDocenteDialog: false,
					filters: [{
							'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
					}],									
					validarErrores: {},
					submitted: false
				}
		},		
		created() {
			this.initialize();
			this.initFilters();
		},
		mounted() {
			this.readDocentes();
		},
		methods: {
			initialize () {
			this.readDocentes();
			}, 
			readDocentes: async function() {   //Leer datos desde el API REST
				const data = await apiDocentesAdmin.readDocentes(); //llamar al API 
				this.listaDocentes = data;
			},	
			insertDocente: async function() { 
				const requestData = {					
					noPlaza: this.newdocenteItem.noPlaza,
					nombreDocente: this.newdocenteItem.nombre,
					apellidoPaterno: this.newdocenteItem.apellidoPaterno,
					apellidoMaterno: this.newdocenteItem.apellidoMaterno
				};
				
				await apiDocentesAdmin.createDatosDocente(requestData); //Insertar el item mediante API REST     
				this.newdocenteItem.noPlaza = "";
				this.newdocenteItem.nombre = "";
				this.newdocenteItem.apellidoPaterno = "";
				this.newdocenteItem.apellidoMaterno = "";
				
				this.readDocentes();
				this.$toast.add({severity:'success', summary: 'Confirmación', detail: 'Docente registrado', life: 3000});
			},	
			updateDatosDocente: async function() { 
				const requestData = {
					noPlaza: this.newdocenteItem.noPlaza,
					nombreDocente: this.newdocenteItem.nombre,
					apellidoPaterno: this.newdocenteItem.apellidoPaterno,
					apellidoMaterno: this.newdocenteItem.apellidoMaterno
				};
				
				await apiDocentesAdmin.updateDatosDocente(this.newdocenteItem.noPlaza,requestData); 
				this.newdocenteItem.noPlaza = "";
				this.newdocenteItem.nombre = "";
				this.newdocenteItem.apellidoPaterno = "";
				this.newdocenteItem.apellidoMaterno = "";
				this.readDocentes();
				this.$toast.add({severity:'success', summary: 'Confirmación', detail: 'Datos Docente modificado', life: 3000});
			},
			deleteDocente: async function() {
				await apiDocentesAdmin.deleteDatosDocente(this.newdocenteItem.noPlaza);								
				this.readDocentes();
				this.deleteDocenteDialog = false;						
				this.$toast.add({severity:'success', summary: 'Acción correcta', detail: 'Docente eliminado ', life: 3000});
			},
			openNew() {	
				this.submitted = false;
				this.newdocenteItem={
					noPlaza:'',
					nombre:'',
					apellidoPaterno:'',
					apellidoMaterno:''
				}
				this.nuevoDocenteDialog = true;
			},
			hideDialog() {
				this.nuevoDocenteDialog = false;
				this.submitted = false;
			},
			hideDialogEditar() {
				this.editarDialog = false;
				this.submitted = false;
			},
			initFilters() {
            this.filters = {
				'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
				}
			},
			saveDocente() {
				this.submitted = true;
				if (this.validarForm() ) {				
					this.insertDocente();
					this.hideDialog();
				}
			},
			editDocente() {
				this.submitted = true;
				if (this.validarForm() ) {				
					this.updateDatosDocente();
					this.hideDialogEditar();
				}
			},
			validarForm() {
				if (!this.newdocenteItem.noPlaza.trim())
					this.validarErrores['noPlaza'] = true;
				else
					delete this.validarErrores['noPlaza'];

				if (!this.newdocenteItem.nombre.trim())
					this.validarErrores['nombre'] = true;
				else
					delete this.validarErrores['nombre'];
				
				if (!this.newdocenteItem.apellidoPaterno.trim())
					this.validarErrores['apellidoPaterno'] = true;
				else
					delete this.validarErrores['apellidoPaterno'];
				
				if (!this.newdocenteItem.apellidoMaterno.trim())
					this.validarErrores['apellidoMaterno'] = true;
				else
					delete this.validarErrores['apellidoMaterno'];

				return !Object.keys(this.validarErrores).length;
			},		
			confirmDeleteDocente(docente) {				
				this.newdocenteItem.noPlaza = docente.noPlaza;				
				this.deleteDocenteDialog = true;				
			},
			showeditDocente(docentedata) {
				//Son los valores de los campos del Datatable
				this.newdocenteItem={
					noPlaza: docentedata.noPlaza,
					nombre: docentedata.nombreDocente,
					apellidoPaterno: docentedata.apellidoPaterno,
					apellidoMaterno: docentedata.apellidoMaterno
				} 
				this.editarDialog = true;				
			},
			showCV(docentedata) {
				
				this.newdocenteItem={
					noPlaza: docentedata.noPlaza
				}				
				this.mostrarCVDialog = true;				
			}
		}
	}
</script>

<style scoped lang="scss">
	.table-header {
		display: flex;
		justify-content: space-between;
	}
</style>
